module.exports = __webpack_public_path__ + "img/male.07b4ced6.jpg";